export const PRESENCE_ONLINE = 'online';
export const PRESENCE_OFFLINE = 'offline';
